import React, { Fragment, FC } from "react";
import { Link } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";
import "./navbar.style.scss";
import { Instagram } from "@mui/icons-material";
import { colors } from "../../constants/site-content";

export const Social: FC = () => {
  return (
    <>
      <Link to="https://www.instagram.com/croqee/">
        <Instagram
          sx={{ width: "60px", height: "60px", color: colors.brandColor }}
        />
      </Link>
    </>
  );
};
